export default __webpack_public_path__ + "static/media/PUBLI_2_ORG_13.81580aeb.png";